// require this file for form-components functionality, jQuery must be required beforehand

require('./form');

require('./tooltip');

import initModals from './modal';
initModals();
